import { apiClient as axios } from '../lib/authClient';

/**
 * ส่งข้อความคุยกับ Copilot 2.0
 */
export const sendCopilotChat = async (message, history = [], context = {}) => {
    try {
        const response = await axios.post('/copilot/chat', {
            message,
            history,
            context
        }, {
            timeout: 180000
        });
        return response.data?.data || response.data;
    } catch (error) {
        console.error('Copilot Chat Error:', error);
        throw error;
    }
};

/**
 * ยืนยันการสั่งการ Action Proposal (เช่น บันทึก Task หรือเปลี่ยน Stage)
 */
export const executeCopilotAction = async (actionType, payload) => {
    try {
        const response = await axios.post('/copilot/action/execute', {
            action_type: actionType,
            payload
        });
        return response.data;
    } catch (error) {
        console.error('Copilot Execute Action Error:', error);
        throw error;
    }
};

/**
 * ดึงคำแนะนำ Quick Prompts ตามบริบทหน้าจอ
 */
export const getCopilotContextPrompts = async (type = 'general', id = null) => {
    try {
        const response = await axios.get('/copilot/context-prompts', {
            params: { type, id }
        });
        return response.data?.data || [];
    } catch (error) {
        console.error('Copilot Context Prompts Error:', error);
        return [];
    }
};

export default {
    sendCopilotChat,
    executeCopilotAction,
    getCopilotContextPrompts
};
